import React, { useState } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { TAccordionProps } from "../../types/PrivacyStatement.types";
import "./index.scss";


const Accordion = (props: TAccordionProps) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div className="privacy-statement-v2-accordion">
      <div className={`privacy-statement-v2-accordion__title ${isOpen ? "open" : ""}`} onClick={() => setOpen(!isOpen)}>
        <span className="accordion-plus-icon"></span>
        {props.accordionContentTitle?.value}
      </div>
      <div className={`privacy-statement-v2-accordion__detail  ${isOpen ? "extended" : ""}`} >
        <RichText field={props.accordionContentDetail} />
      </div>
    </div>
  );
};

export default Accordion;
